import { IWalletDetails } from "@market/interfaces/IWallet";

export const tradeAnyRestrictionMessage =
  "Restricted Access: You cannot trade crypto assets at the moment, please check that you are Tier 1 and completed any pending requests on your BFID dashboard. In case of any further doubts, please reach out to support";

export const tradeUnstakeRestrictionMessage =
  "Restricted Access: You cannot unstake ETH at the moment, please check that you are Tier 1 and completed any pending requests on your BFID dashboard. In case of any further doubts, please reach out to support";
export const tradeStakeRestrictionMessage =
  "Restricted Access: You cannot stake ETH at the moment, please check that you are Tier 1 and completed any pending requests on your BFID dashboard. In case of any further doubts, please reach out to support";
export const tradeUserStatementRestrictionMessage =
  "Restricted Access: You opted out of trading crypto assets in your Tier 1 Suitability session. To unlock trading, please start a new session, select 'Yes,' and update your preferences.";

export const withdrawValidationMessages = (
  verificationUrl = "/redirect_to_identity_verification",
  securityUrl = window.location.href.split("/funds")[0] +
    "/account?tab=security"
) => {
  return {
    restricted_by_admin: `Your withdrawals has been restricted. Please contact support
      <a href="/support" title="Support link"> here </a>.`,
    missing_2fa: `Please set up 2FA <a href="${securityUrl}">here.</a>`,
    investor_unverified: `To perform this action you need to be verified.
       Please verify Your identity <a href="${verificationUrl}">here.</a>`,
    restricted_by_currency: `Withdraw for this currency is restricted.`,
  };
};

export const depositValidationMessages = (
  verificationUrl = "/redirect_to_identity_verification",
  isUsInvestor?: boolean,
  wallet?: IWalletDetails
) => ({
  restricted_by_admin: `Your deposits has been restricted. Please contact support
    <a href="/support" title="Support link"> here </a>.`,
  restricted_by_currency: "Deposit for this currency is restricted.",
  restricted_by_currency_for_country:
    depositValidationRestrictedByCurrencyForCountry(
      wallet?.currency,
      isUsInvestor
    ),
  investor_unverified: `To perform this action you need to be verified.
  Please verify Your identity <a href="${verificationUrl}">here.</a>`,
  restricted_temporary:
    "All deposits has been restricted due to maintenance. Please try again in a few minutes.",
  currency_restricted_by_admin: "Deposit for this currency is restricted.",
});

export const buyValidationMessages = (
  wallet: IWalletDetails,
  verificationUrl = "/redirect_to_identity_verification",
  isUsInvestor?: boolean
) => ({
  restricted_by_admin: tradeAnyRestrictionMessage,
  restricted_by_country: buyValidationRestrictedByCountry(
    wallet.currency,
    isUsInvestor
  ),
  investor_unverified: `To purchase ${wallet.currency_name} you need to be verified.
  Please verify your identity on BF ID <a href="${verificationUrl}">here.</a>`,
  restricted_by_currency: `Purchases of ${wallet.currency.toUpperCase()} are restricted.`,
  cap_exceeded: "You are not able to purchase more tokens.",
  restricted_by_user_statement: tradeUserStatementRestrictionMessage,
});

export const sellValidationMessages = (
  wallet: IWalletDetails,
  verificationUrl = "/redirect_to_identity_verification",
  isUsInvestor?: boolean
) => ({
  restricted_by_currency: `Sales of ${wallet.currency.toUpperCase()} is restricted.`,
  investor_unverified: `To perform this action you need to be verified.
    Please verify Your identity <a href="${verificationUrl}">here.</a>`,
  restricted_by_admin: tradeAnyRestrictionMessage,
  restricted_by_country: isUsInvestor
    ? "As a US investor, you are not allowed to access the trading feature at this time due to the US regulations"
    : `Your sales have been restricted. Please contact support
    <a href="/support" title="Support link" > here.</a>.`,
  restricted_by_user_statement: tradeUserStatementRestrictionMessage,
});

const depositValidationRestrictedByCurrencyForCountry = (
  currency?: string,
  isUs?: boolean
) => {
  if (isUs && currency === "bft") {
    return `Unfortunately the deposit feature (except BFT) is not available for US investors.<br>
      This is due to US regulatory restrictions where investors can only invest directly into pitches
      that have an escrow with a US Bank. You can check pitches
      <a href="//${process.env.DOMAIN}/search/pitches">here</a> and invest directly rather than depositing.`;
  }

  if (isUs) {
    return `As a US investor, you are not allowed to access the trading feature at this time due to the US regulations`;
  }

  return `You are not able to deposit this currency due to country restrictions.`;
};

const buyValidationRestrictedByCountry = (currency: string, isUs?: boolean) => {
  if (isUs && currency === "bft") {
    return `Unfortunately US regulations restrict US resident investors from buying BFT.
        You can explore purchasing them through an external exchange like Uniswap. Full list of exchanges can be found
        <a href="https://coinmarketcap.com/currencies/bnktothefuture/markets/"
          target="_blank" rel="noopener noreferrer"> here.
        </a>`;
  }

  if (isUs) {
    return `As a US investor, you are not allowed to access the trading feature at this time due to the US regulations`;
  }

  return `Your purchases have been restricted. Please contact support
        <a href="/support" title="Support link" > here.</a>`;
};
